{
  "user-profile": {
    "buttons": {
      "confirm-email": "Xác nhận email",
      "confirm-phone-nr": "Xác nhận số điện thoại",
      "update": "Cập nhật",
      "update-password": "Cập nhật mật khẩu",
      "update-phone-nr": "Cập nhật số điện thoại"
    },
    "text": {
      "communication": "Kênh giao tiếp",
      "communication-hint": "Phương thức liên lạc chủ yếu của các Salon là thông qua Email (ví dụ như cho việc xác nhận lịch hẹn). Tuy nhiên có một số salon có cho phép việc liên hệ qua SMS. Bạn có muốn nhận tin nhắn SMS trong trường hợp này không?",
      "confirm-email": "Vui lòng xác minh email của bạn",
      "confirm-phone-nr": "Vui lòng xác minh số điện thoại của bạn",
      "contact-data": "Thông tin liên hệ",
      "in-second": "sau {{seconds}} giây",
      "password": "Mật khẩu",
      "personal-data": "Dữ liệu cá nhân",
      "pin-code": "Mã PIN",
      "pin-code-hint": "Nhập đầy đủ tất cả {{ numberOfPinDigit }} số để có thể cập nhật mã PIN mới. Mã PIN này chỉ được dùng để đăng nhập trên ứng dụng Beauty Checkin và Beauty Checkout.",
      "update-password-by-email": "Mã PIN sẽ được gửi cho bạn qua email. Bạn sẽ cần mã PIN này để xác nhận mật khẩu mới của mình.",
      "update-password-by-sms": "Mã PIN sẽ được gửi cho bạn qua SMS. Bạn sẽ cần mã PIN này để xác nhận mật khẩu mới của mình.",
      "update-success": "Cập nhật thành công!",
      "via-email": "Không",
      "via-sms": "Có"
    }
  }
}
